var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"singularity-top-nav-mobile",class:{ 'is-mobile': _vm.isMobile }},[_c('IconButton',{attrs:{"size":16,"icon":"MobileIcon","active":_vm.isMobile},on:{"click":_vm.toggleMobileBreakpoint}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }